import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import { adaptHealth, type ApiHealth } from '@/lib/fleet-adapters';
import type { FleetHealth } from '@/types/fleet';

import { fleetKeys } from './fleet-keys';

/** Powers the "Fleet API: healthy / degraded" header badge. */
export function useFleetHealth(): UseQueryResult<FleetHealth, Error> {
  return useQuery({
    queryKey: fleetKeys.health(),
    queryFn: async ({ signal }) =>
      adaptHealth(await apiClient.get<ApiHealth>(fleetPath('/health'), signal)),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    staleTime: 15_000,
  });
}
